// extracted by mini-css-extract-plugin
export default {"item":"Menu_item__efXqf","menu":"Menu_menu__TWMlu","divisor":"Menu_divisor__x564O","link":"Menu_link__a+fQi","linkAtivo":"Menu_linkAtivo__i2RaQ"};